"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XyriasPardonAbilityHandler = exports.XyriasPardonActorAbilityFactory = exports.XyriasPardonAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Resurrect_1 = require("../../core/effects/core/Resurrect");
const ApplyEffect_1 = require("../../core/event-handlers/core/ApplyEffect");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class XyriasPardonAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.XyriasPardon;
        this.__typeName = "XyriasPardon";
    }
}
exports.XyriasPardonAbilityArgs = XyriasPardonAbilityArgs;
let XyriasPardonActorAbilityFactory = class XyriasPardonActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("XyriasPardon", "Self", 0, 1);
    }
};
XyriasPardonActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("XyriasPardon")
], XyriasPardonActorAbilityFactory);
exports.XyriasPardonActorAbilityFactory = XyriasPardonActorAbilityFactory;
let XyriasPardonAbilityHandler = class XyriasPardonAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.registerEventHandler(ability.invokerId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new ApplyEffect_1.ApplyEffectEventHandlerArgs(ability.invokerId, Target_1.Target.Self, Duration_1.Duration.Instant, new Resurrect_1.ResurrectEffectArgs("XyriasPardon")));
    }
};
XyriasPardonAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.XyriasPardon)
], XyriasPardonAbilityHandler);
exports.XyriasPardonAbilityHandler = XyriasPardonAbilityHandler;
